<template>
    <div class="max-container">
        <template v-if="chartDataExists">
            <div class="d-flex justify-content-end">
                <div class="compare-open">
                    <transition name="fade" mode="out-in">
                        <button v-if="!compareOpen" key="openComparison" class="add-comparison" @click="openComparison">
                            <span class="icon icon--inline icon--add"></span> Add Comparison
                        </button>
                        <button v-if="compareOpen" key="closeComparison" :class="{ 'is-compare-open': compareOpen }" @click="closeComparison">
                            <span class="icon icon--inline icon--remove"></span> Remove Comparison
                        </button>
                    </transition>
                </div>
            </div>
            <div class="row no-gutters flex-nowrap toggle-wrapper">
                <div key="left" ref="leftChart" class="left-chart" :class="{ 'col-md-12': !compareOpen, 'col-md-6': compareOpen, 'left-split': compareOpen }">
                    <toggle-chart-container :updateFilters="true"></toggle-chart-container>
                </div>
                <transition name="compa" class="row no-gutters justify-content-between">
                    <div key="right" v-if="compareOpen" class="right-chart col-md-6" :class="{ 'right-split': compareOpen }">
                        <toggle-chart-container></toggle-chart-container>
                    </div>
                </transition>
            </div>
        </template>
        <h1 v-else class="no-data">
            No data for those filters
        </h1>
    </div>
</template>

<script>
    import ToggleChartContainer from '@/components/ToggleChartContainer';
    import store from '@/store';


    export default {
        components: {
            ToggleChartContainer,
        },
        computed: {
            chartDataExists() {
                return store.state.chartData.data.length;
            },
            compareOpen() {
                return store.state.compareChartOpen[store.state.currentTab];
            },
        },
        methods: {
            openComparison() {
                store.dispatch('openCompare', { tab: store.state.currentTab });
            },
            closeComparison() {
                store.dispatch('closeCompare', { tab: store.state.currentTab });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';
    @import '../assets/scss/partials/mixins';

    .chart-container {
        margin-bottom: 63px;

        @media screen and (min-width: $tablet) {
            margin-bottom: 50px;
        }
    }

    .toggle-wrapper {
        overflow: visible;
    }

    .no-data {
        margin-bottom: 43px;
        color: $kpmg-blue;
        text-align: center;
    }

    .left-chart {
        transition-property: all;
        transition-timing-function: linear;
        transition-duration: 0.5s;
    }

    .left-split {
        padding-left: 0;
        padding-right: 10px;
    }

    .right-split {
        padding-left: 10px;
        padding-right: 0;
    }

    .fade-leave-active,
    .fade-enter-active {
        transition: opacity 0.4s ease;
    }

    .fade-enter,
    .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .fade-enter-to,
    .fade-leave {
        opacity: 1;
    }

    .compa-leave-active.right-chart {
    }
    .compa-leave.right-chart {
        opacity: 1;
    }
    .compa-leave-to.right-chart {
        flex: 0 0 0;
        max-width: 0;
        opacity: 0;
    }

    .compa-enter-active {
    }
    .compa-enter.right-chart {
        opacity: 0;
        flex: 0 0 0;
        max-width: 0;
    }
    .compa-enter-to.right-chart {
        opacity: 1;
    }

    .right-chart {
        transition-property: all;
        transition-duration: 0.5s;
        transition-timing-function: linear;
    }

    .card {
        height: 100%;
    }

    .compare-open-wrapper {
        position: relative;
    }

    .compare-open {
        padding: 6px 0;

        cursor: pointer;

        z-index: 1;

        &.is-compare-open {
            position: relative;
        }

        .icon {
            vertical-align: middle;
        }

        button {
            @include fontArial();
            font-size: 16px;
            letter-spacing: 0.9px;
            color: $kpmg-blue;
            cursor: pointer;
        }

        .add-comparison {
            display: none;

            @media screen and (min-width: $desktop) {
                display: block;
            }
        }

        .remove-comparison {
            display: none;

            &.is-compare-open {
                display: block;
            }

            @media screen and (min-width: $desktop) {
                display: block;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BigChartContainer.vue